<script>
  import solicitacaoCancelamentoContratoServico from '../servico';
  import $ from 'jquery';
  import Paginacao from '~componentes/Paginacao.vue';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import ModalLiberarCancelar from '~componentes/ModalLiberarCancelar.vue';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';


  export default {
    components: { Paginacao, ModalLiberarCancelar, ModalMensagem, ModalArquivosSolicitacao },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        solicitacoes: [],
        carregando: true,
        filtros: this.camposFiltros(),
        solicitacaoSelecionada: null,
        salvandoLiberacao: false,
        animated: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
        modalLiberarCancelar: false,
        modalMensagem: false,
        modalArquivos: false,
      }
    },
    methods: {
      camposFiltros() {
        return {
          beneficiario: '',
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.lista();
      },
      filtrar() {
        this.lista();
      },
      lista(pagina = 1) {
        this.$root.botaoAcaoMostrar = false;

        this.carregando = true;

        return solicitacaoCancelamentoContratoServico.lista(pagina, this.filtros)
          .then(res => {
            this.carregando = false;

            this.solicitacoes = res.body.registros;
            this.totalRegistros = res.body.totalRegistros;
            this.totalPaginas = res.body.totalPaginas;
            this.registrosPorPagina = res.body.registrosPorPagina;
          });
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      liberadoOuCancelado(solicitacao) {
        return (solicitacao.statusLibCanc > 0);
      },
      status(solicitacao) {
        if (solicitacao.idSolicitacaoCancelamentoContrato === 0)
          return '---';

        if (solicitacao.statusSolicitacao === 1) {
          return 'Liberada pela instituição';
        } else if (solicitacao.statusSolicitacao === 2) {
          return 'Cancelada pela instituição';
        } else if (solicitacao.statusSolicitacao === 3) {
          return 'Cancelada pelo coordenador';
        } else if (solicitacao.statusSolicitacao === 4) {
          return 'Liberada pelo coordenador';
        } else if (solicitacao.statusSolicitacao === 0) {
          return 'Aguardando liberação';
        }
      },
      mostrarModalLiberarCancelar(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalLiberarCancelar = true;
      },
      modalLiberarCancelarFechado() {
        this.animated = false;
        this.modalLiberarCancelar = false;
        this.solicitacaoSelecionada = null;
      },
      liberar() {
        this.salvandoLiberacao = true;

        solicitacaoCancelamentoContratoServico
          .liberar(this.solicitacaoSelecionada.idSolicitacaoCancelamentoContrato)
          .then(status => {
            this.modalLiberarCancelar = false;

            if (status.liberado) {
              toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacaoCancelamentoContrato} liberada com sucesso.`);
            } else {
              toastr.warning(`Você não tem permissão para liberar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
            }

            this.salvandoLiberacao = false;
            this.solicitacaoSelecionada = null;
          })
          .then(this.lista);
      },
      cancelar() {
        this.salvandoLiberacao = true;

        solicitacaoCancelamentoContratoServico
          .cancelar(this.solicitacaoSelecionada.idSolicitacaoCancelamentoContrato)
          .then(status => {
            this.modalLiberarCancelar = false;

            if (status.cancelado) {
              toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacaoCancelamentoContrato} cancelada com sucesso.`);
            } else {
              toastr.warning(`Você não tem permissão para cancelar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
            }

            this.salvandoLiberacao = false;
            this.solicitacaoSelecionada = null;
          })
          .then(this.lista);
      },
      liberadoOuCancelado(solicitacao) {
        return !!solicitacao.liberacaoCoordenador || !!solicitacao.statusSolicitacao;
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
        this.lista(this.pagina);
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },
    },
    created() {
      if (this.$route.params.filtrosBag) 
        this.filtros = this.$route.params.filtrosBag;

      this.lista(this.pagina);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação Cancelamento Contrato - Lista';
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederRota = '';
      this.$root.botaoAcaoTexto = '';
      this.$root.botaoRetrocederMostrar = false;

      const _this = this;

      if (this.$route.params.filtrosBag)
        if (this.filtros.filtrar)
          $('.ibox').removeClass('collapsed');
    },
    watch: {
      '$route': 'lista'
    },
  }
</script>

<style scoped>
  .mensagemNaoLida {
    font-size: 1.20em;
    color: #1d9d74;
    margin-right: 3px;
  }
</style>

<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">
    <modal-liberar-cancelar :mostrar="modalLiberarCancelar"
                            :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCancelamentoContrato : ''"
                            :salvando="salvandoLiberacao"
                            :liberando="true"
                            :mensagem="''"
                            @fechado="modalLiberarCancelarFechado"
                            @liberar="liberar"
                            @cancelar="cancelar">
    </modal-liberar-cancelar>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCancelamentoContrato : ''"
                    tipo="SolCancelamentoContrato"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCancelamentoContrato : ''"
                                tipo="cancelamentocontrato"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>
          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="beneficiario">Beneficiário</label>

                  <input type="text"
                         class="form-control"
                         id="beneficiario"
                         v-model="filtros.beneficiario">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-primary no-margins" @click="filtrar">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-search"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">

            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                  <tr>
                    <th v-if="!configuracao.naoUtilizarMensageria">Mensagens</th>
                    <th>Nº contrato </th>
                    <th>Sol web</th>
                    <th>Data solicitação</th>
                    <th>Nome solicitante</th>
                    <th>Projeto</th>
                    <th>Beneficiário</th>
                    <th>Tipo</th>
                    <th>Vigência início</th>
                    <th>Vigência final</th>
                    <th>Valor</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(solicitacao, index) in solicitacoes">
                    <td v-if="!configuracao.naoUtilizarMensageria">
                      <div v-if="solicitacao.quantidadeNaoLida > 0">
                        <i class="fa fa-info-circle mensagemNaoLida" v-tooltip="'Leitura pendente'"></i> {{solicitacao.quantidadeNaoLida}}
                      </div>
                    </td>
                    <td>{{ solicitacao.numeroContrato }}</td>
                    <td>{{ solicitacao.idSolicitacaoCancelamentoContrato || '---' }}</td>
                    <td>{{ solicitacao.dataSolicitacao || '---' }}</td>
                    <td>{{ solicitacao.nomeSolicitante || '---' }}</td>
                    <td>{{ solicitacao.nomeProjeto || '---' }}</td>
                    <td>{{ solicitacao.documento || '---' }} - {{ solicitacao.beneficiario }}</td>
                    <td>{{ solicitacao.tipoSolicitacao }}</td>
                    <td>{{ solicitacao.vigenciaContrato | formatarNumeroEmData }}</td>
                    <td>{{ solicitacao.vigenciaContratoFim | formatarNumeroEmData }}</td>
                    <td>{{ solicitacao.valor | formatarNumero }}</td>
                    <td>{{ status(solicitacao) }}</td>
                    <td>

                      <router-link class="btn btn-primary btn-xs"
                                   active-class=""
                                   v-tooltip="'Relatório'"
                                   v-if="solicitacao.idSolicitacaoCancelamentoContrato > 0"
                                   :to="{ name: 'solicitacao-cancelamento-contrato.relatorio', params: { id: solicitacao.idSolicitacaoCancelamentoContrato , filtrosBag: filtros } }">
                        <i class="fa fa-file-text-o"></i>
                      </router-link>

                      <router-link tag="button"
                                   class="btn btn-danger btn-xs"
                                   active-class=""
                                   v-tooltip="'Solicitar cancelamento do contrato'"
                                   :disabled="liberadoOuCancelado(solicitacao)"
                                   :to="{ name: 'solicitacao-cancelamento-contrato.editar', params: { id: solicitacao.idSolicitacaoCancelamentoContrato,
                                                                                                      idCript:  solicitacao.idSolicitacao,
                                                                                                      idContrato: solicitacao.idContrato,
                                                                                                      idProjeto: solicitacao.idProjeto} }">
                        <i class="fa fa-ban"></i>
                      </router-link>

                      <button :disabled="liberadoOuCancelado(solicitacao)"
                              class="btn btn-warning btn-xs"
                              v-tooltip="'Liberar ou Cancelar solicitação'"
                              v-if="solicitacao.idSolicitacaoCancelamentoContrato > 0"
                              @click="mostrarModalLiberarCancelar(solicitacao)">
                        <i class="fa fa-check"></i>
                      </button>

                      <button type="button"
                              class="btn btn-info btn-xs"
                              v-tooltip="'Listar ou adicionar arquivos da solicitação'"
                              @click="mostrarModalArquivos(solicitacao)"
                              v-if="configuracao.usarArquivosSolicitacaoCancelamentoContrato && solicitacao.idSolicitacaoCancelamentoContrato > 0">
                        <i class="fa fa-archive"></i>
                      </button>

                      <button type="button"
                              class="btn btn-success btn-xs"
                              v-tooltip="'Ler\Enviar mensagem'"
                              v-if="solicitacao.idSolicitacaoCancelamentoContrato > 0 && !configuracao.naoUtilizarMensageria"
                              @click="mostrarModalMensagem(solicitacao)">
                        <i class="fa fa-comment"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="carregando">
                    <td colspan="12">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true">
            </paginacao>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-cancelamento-contrato/componentes/SolicitacaoCancelamentoContratoLista.vue